import { MaskedLine, Reveal } from "@/components/Reveal";

export const PageHero = ({ kicker, lines, intro, dark = true }) => (
  <section className="relative bg-navy overflow-hidden" data-testid="page-hero">
    <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
      <div className="absolute -right-10 top-6 font-display font-black uppercase text-[22vw] leading-none text-outline-cream select-none">
        DG
      </div>
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-14 sm:pt-24 sm:pb-20">
      <Reveal y={12}>
        <p className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-gold mb-5" data-testid="page-hero-kicker">
          {kicker}
        </p>
      </Reveal>
      <h1 className="font-display font-black uppercase tracking-tight leading-[0.95] text-cream text-4xl sm:text-5xl lg:text-6xl">
        {lines.map((l, i) => (
          <MaskedLine key={l} delay={0.15 + i * 0.12} className={i === lines.length - 1 ? "text-crimson" : ""}>
            {l}
          </MaskedLine>
        ))}
      </h1>
      {intro && (
        <Reveal delay={0.5} className="mt-6 max-w-2xl">
          <p className="text-cream/70 text-base sm:text-lg leading-relaxed">{intro}</p>
        </Reveal>
      )}
    </div>
    <div className="h-1.5 bg-crimson" />
  </section>
);

export default PageHero;
